//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ReactNode } from "react";


//-------------------------------------------------------------------------------------------------- Interfaces
export interface AlertSliceInterface {
    show: boolean;
    isReceiptPayment?: boolean;
    type: "INFO" | "SUCCESS" | "ERROR";
    title: string;
    subtitle?: string;
    message: string,
    extraComponents?: ReactNode;
    onFinalize: Function | undefined;
    paymentData?: PaymentData
};

export interface PaymentData {
    date: string,
    time: string,
    amount?: string,
    name: string,
    client: string,
    card?: string,
    idTransaction?: string,
    concept?: string,
}



//-------------------------------------------------------------------------------------------------- Vars and consts
const alertPaymentDataInitialState = {
    amount: "",
    date: "",
    time: "",
    name: "",
    client: "",
    card: "",
    idTransaction: "",
    concept: ""
} as PaymentData;

const alertSliceInitialState = {
    show: false,
    isReceiptPayment: false,
    type: "SUCCESS",
    title: "",
    subtitle: "",
    message: "",
    extraComponents: undefined,
    onFinalize: undefined,
    paymentData: alertPaymentDataInitialState
} as AlertSliceInterface;



//-------------------------------------------------------------------------------------------------- Slice
const alertSlice = createSlice({
    name: "alert",
    initialState: alertSliceInitialState,
    reducers: {
        setAlert: (state, action: PayloadAction<AlertSliceInterface>) => {
            state.show = action.payload.show;
            state.isReceiptPayment = action.payload.isReceiptPayment;
            state.type = action.payload.type;
            state.title = action.payload.title;
            state.subtitle = action.payload.subtitle;
            state.message = action.payload.message;
            state.paymentData = action.payload.paymentData;
            state.extraComponents = action.payload.extraComponents;
            state.onFinalize = () => {(action.payload.onFinalize) && action.payload.onFinalize()};
        },
        showAlert: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        clearAlert: (state) => {
            state.show = alertSliceInitialState.show;
            state.type = alertSliceInitialState.type;
            state.title = alertSliceInitialState.title;
            state.message = alertSliceInitialState.message;
            state.onFinalize = alertSliceInitialState.onFinalize;
        }
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export const {setAlert, showAlert, clearAlert} = alertSlice.actions;
export const getAlertData = (state: any) => (state.alert) as AlertSliceInterface;
export default alertSlice.reducer;
